import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import trackingHelper from '../../helpers/tracking';
import * as Styled from '../TrolleyItem/TrolleyItem.styles';

var CategoryItem = function CategoryItem(_ref) {
  var categoryId = _ref.categoryId,
      attributes = _ref.attributes,
      moduleIndex = _ref.moduleIndex,
      trackingOptions = _ref.trackingOptions,
      itemType = _ref.itemType,
      onClick = _ref.onClick;

  var onClickCategory = function onClickCategory() {
    return onClick({
      itemType: itemType,
      moduleIndex: moduleIndex,
      attributes: attributes
    });
  };

  var categoryName = attributes.name.replace(/\s/g, '-');
  var trackingParams = trackingHelper(_objectSpread(_objectSpread({}, trackingOptions), {}, {
    categoryName: categoryName
  }));
  var url = "/search/".concat(categoryName).concat(trackingParams);
  var img = "//media.4rgos.it/i/Argos/".concat(categoryId, "_CAM");
  return /*#__PURE__*/React.createElement(Styled.Item, {
    className: "add-to-trolley-item add-to-trolley-item--category",
    "data-module-index": moduleIndex
  }, /*#__PURE__*/React.createElement(Styled.ItemRow, {
    as: "a",
    href: url,
    className: "xs-row add-to-trolley-item__row",
    onClick: onClickCategory
  }, /*#__PURE__*/React.createElement(Styled.Thumbnail, null, /*#__PURE__*/React.createElement(Image, {
    src: img,
    height: 65,
    width: 65,
    alt: attributes.name
  })), /*#__PURE__*/React.createElement(Styled.Detail, {
    className: "add-to-trolley-item__name"
  }, attributes.name)));
};

CategoryItem.propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  itemType: PropTypes.string,
  moduleIndex: PropTypes.number,
  attributes: PropTypes.shape({
    name: PropTypes.string
  }),
  trackingOptions: PropTypes.shape({
    page: PropTypes.string,
    pageId: PropTypes.string,
    placement: PropTypes.string,
    innerPlacement: PropTypes.string,
    sectionTitle: PropTypes.string,
    strategy: PropTypes.string
  }),
  onClick: PropTypes.func
};
CategoryItem.defaultProps = {
  itemType: 'category',
  attributes: {},
  trackingOptions: {},
  onClick: function onClick() {}
};
export default CategoryItem;